// removed by extract-text-webpack-plugin
module.exports = {"container":"_3YXbbQxfKTD6VZIc2EzZC-","item":"_1mFMs1ueg1UO9VOAkiCys4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImagesGrid/style.scss
// module id = 192
// module chunks = 0